import React, { useContext, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Modal,
  notification,
  InputNumber
} from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import mergeProps from "../../utils/MergeProps";
// const { TextArea } = Input;

const TemplatePointsForm = ({
  open,
  isEdit,
  currentTemplatePoint,
  onFinish,
  onCancel,
}) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: currentTemplatePoint.name,
        // description: currentTemplatePoint.description,
        meeting_type_name: currentTemplatePoint.meeting_type_name,
        department_name: currentTemplatePoint.department_name,
        point_type_name: currentTemplatePoint.point_type_name,
        classification_name: currentTemplatePoint.classification_name,
        duration: currentTemplatePoint.duration,
      });
    }
    else{
      form.setFieldsValue({
        duration: 15,
      });
    }
  }, [isEdit, currentTemplatePoint, form, open]);

  const handleComplete = async (values) => {
    try {
      if (isEdit) {
        values.id = currentTemplatePoint.id;
        console.log("values", values);
        const response = await axios.put(
          `${globals.SERVICE_API_DB}/v1/update-point-detail/${currentTemplatePoint.id}`,
          values,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        if (response?.data?.status === 0) {
          currentTemplatePoint = mergeProps(
            currentTemplatePoint,
            response?.data?.data
          );
          onFinish({ status: "edited" });
        }
        form.resetFields();
        return;
      }
      const response = await axios.post(
        `${globals.SERVICE_API_DB}/v1/create-template-point`,
        values,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      onFinish({ status: "created", newTemplatePoint: response?.data?.data });
      form.resetFields();
    } catch (error) {
      console.error("Error submitting form:", error.response);
      notification.error({
        message: "Error guardando punto de plantilla",
        placement: "bottomRight",
      });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={isEdit ? "Editar Punto de plantilla" : "Crear Punto de plantilla"}
      open={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={null}
    >
      {/* <LoadingModal open={loading} /> */}
      <Form form={form} layout="vertical" onFinish={handleComplete}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="meeting_type_name"
              label="Tipo de reunión"
              rules={[{ required: true, message: "No se permite dejar en blanco" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="department_name"
              label="Departamento"
              rules={[{ required: true, message: "No se permite dejar en blanco" }]}
            >
               <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="point_type_name"
              label="Tipo de punto"
              rules={[{ required: true, message: "No se permite dejar en blanco" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="classification_name"
              label="Clasificación"
              rules={[{ required: true, message: "No se permite dejar en blanco" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="name"
          label="Nombre del punto"
          rules={[{ required: true, message: "Este campo es requerido" }]}
        >
          <Input />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
              <Form.Item label="Duración" name="duration" tooltip="minutos">
                <InputNumber
                  min={1}
                />
              </Form.Item>
          </Col>
        </Row>

        {/* <Form.Item label="Descripción" name="description">
          <TextArea rows={4} />
        </Form.Item> */}

        <Row justify="end">
          <Col>
            <Button style={{ marginRight: 8 }} type="primary" htmlType="submit">
              {isEdit ? "Actualizar" : "Crear"}
            </Button>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default TemplatePointsForm;
